<template>
  <div class="">
    <panel :Title="!$cookies.get('IsAnbohSaz')==false ? 'فرم ارتباط با مدیر' : 'فرم درخواست حضوری'" Des="از طریق این فرم می توانید پیامی در قالب متن را به مدیر سامانه ارسال نمایید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="col-md-1 col-12"></div>
      <div class="col-md-10 col-12">
        <net-pa-card>
          <template slot="header">
            <h6><i class="fas fa-comments mx-2"></i> {{ !$cookies.get('IsAnbohSaz')==false ? 'ارتباط با مدیر' : 'فرم درخواست حضوری' }}</h6>
          </template>
          <template slot="content">
            <div class="row">
              <div class="col-md-4 col-12" v-if="isShowDateTimePicker==true">
                <small>تاریخ حضور</small>
                <date-picker :editable="false" :auto-submit="true"  color="#435ebe" v-model="datetime" type="datetime"> </date-picker>
              </div>
              <div class="col-12 mt-3">
                <small>متن پیام خود را بنویسید</small>
                <textarea class="form-control mt-1" rows="20" v-model="Txt"> </textarea>
              </div>
            </div>
            <buttons class="btn btn-success NetPa-btn float-left mt-1 Pointer" @click="SendMessage"><i class="fas fa-paper-plane" aria-hidden="true"></i> ارسال پیام</buttons>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-1 col-12"></div>
    </div>
  </div>
</template>
<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'

export default {
  data() {
    return {
      datetime:this.$GetJalaliDateTime(),
      Txt: '',
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'InsAzaMessage',
        Token: '',
      },
    }
  },
  components: { NetPaCard, Panel },
  methods: {
    SendMessage() {
      if (this.isShowDateTimePicker==true) {
        this.Txt+=this.Txt+" \n [ "+" درخواست حضور برای : "+ this.datetime +" ] "
      }
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
      formData.append('Message', this.Txt)
      formData.append('ZamanInsert', this.$GetJalaliDateTime())
      this.DataAxiosRow.ArryfildValue = formData
      this.DataAxiosRow.Token = this.$session.get('TokenNetPa')
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (data.result == 'SUCCESS') {
          this.$mySweetDefault('عملیات موفق', 'ارسال پیام با موفقیت انجام شد', 'success', 3000)
          this.Txt = ''
        } else {
          this.$mySweetDefault('خطایی رخ داده است', 'در ارسال پیام خطایی رخ داده است', 'error', 3000)
        }
      })
    },
  },
  props: ['isShowDateTimePicker'],
  created() {
    // console.log(this.isShowDateTimePicker)
  },
}
</script>
<style scoped></style>
